import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { NavigationRoutingModule } from './navigation-routing.module';
import { NavigationComponent } from './navigation.component';
import { InfoMessageComponent } from '../dialogs/info-message/info-message.component';
import { ConfirmationDialogComponent } from '../dialogs/confirmation-dialog/confirmation-dialog.component';
import { SnackBarComponent } from '../snack-bar/snack-bar.component';
import { LoadingSpinnerComponent } from '../dialogs/loading-spinner/loading-spinner.component';
import { SafeHtmlPipe } from '../common/dom-sanitizer';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatCardModule } from '@angular/material/card';
import { MatSortModule } from '@angular/material/sort';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { MatRadioModule } from '@angular/material/radio';
import { FlexLayoutModule } from '@angular/flex-layout';
import { VirtualScrollerModule } from 'ngx-virtual-scroller';
import { TableVirtualScrollModule } from 'ng-table-virtual-scroll';
import { NgxMaskModule } from 'ngx-mask';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { PersistenceModule } from 'angular-persistence';
import { MatTreeModule } from '@angular/material/tree';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatStepperModule } from '@angular/material/stepper';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { DateAdapter, MatNativeDateModule, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatTableModule } from '@angular/material/table';
import { MatInputModule } from '@angular/material/input';
import {MatSliderModule} from '@angular/material/slider';
import { MatListModule } from '@angular/material/list';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatBadgeModule } from '@angular/material/badge';
import { MatMenuModule } from '@angular/material/menu';
import { AuthGuard } from '../guards/auth.guard';
import { JwtService } from '../jwt.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MomentUtcDateAdapter } from '../moment.utc';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MAT_MOMENT_DATE_FORMATS } from '@angular/material-moment-adapter';
import { ChartsModule } from 'ng2-charts';
import { DeviceDetectorModule } from 'ngx-device-detector';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ResizableModule } from 'angular-resizable-element';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBarModule, MAT_SNACK_BAR_DEFAULT_OPTIONS } from '@angular/material/snack-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { UtcdatetimePipe } from '../custom-pipes/utcdatetime.pipe';
import { FilteredDataLengthPipe } from '../custom-pipes/filtered-data-length.pipe';
import { FormatCurrencyPipe } from '../custom-pipes/format-currency.pipe';
import { GetColWidthPipe } from '../custom-pipes/get-col-width.pipe';
import { CheckIfCellSelectedPipe } from '../custom-pipes/check-if-cell-selected.pipe';
import { GetRoutingPipe } from '../custom-pipes/get-routing.pipe';
import { GetUserPipe } from '../custom-pipes/get-user.pipe';
import { GetCountryPipe } from '../custom-pipes/get-country.pipe';
import { GetMNCForMCCPipe } from '../custom-pipes/get-mncfor-mcc.pipe';
import { RoutingRuleValuePipe } from '../custom-pipes/routing-rule-value.pipe';
import { NgxCsvParserModule } from 'ngx-csv-parser';
import { NgxQRCodeModule } from '@techiediaries/ngx-qrcode';
import { DlrPoliciesComponent } from '../dlrs/dlr-policies/dlr-policies.component';
import { AddDlrPolicyComponent } from '../dlrs/dlr-policies/add-dlr-policy/add-dlr-policy.component';
import { DlrUndelMccComponent } from '../dlrs/dlr-undel-mcc/dlr-undel-mcc.component';
import { DlrUndelMsisdnComponent } from '../dlrs/dlr-undel-msisdn/dlr-undel-msisdn.component';
import { DlrSummaryComponent } from '../dlrs/dlr-summary/dlr-summary.component';
import { ViewDlrSummaryChartComponent } from '../dlrs/dlr-summary/view-dlr-summary-chart/view-dlr-summary-chart.component';
import { MatIconModule } from '@angular/material/icon';
import { RegexEditorComponent } from '../dlrs/regex-editor/regex-editor.component';
import { AceModule } from 'ngx-ace-wrapper';
import { ACE_CONFIG } from 'ngx-ace-wrapper';
import { AceConfigInterface } from 'ngx-ace-wrapper';
import { ClickerSummaryComponent } from '../clicker-summary/clicker-summary.component';

const DEFAULT_ACE_CONFIG: AceConfigInterface = {
  tabSize: 2
};

@NgModule({
    declarations: [
        NavigationComponent, InfoMessageComponent,
        ConfirmationDialogComponent, LoadingSpinnerComponent,
        SnackBarComponent, SafeHtmlPipe,
        UtcdatetimePipe, FilteredDataLengthPipe, FormatCurrencyPipe, GetColWidthPipe, CheckIfCellSelectedPipe,
        GetRoutingPipe, GetUserPipe, GetCountryPipe, GetMNCForMCCPipe, RoutingRuleValuePipe,
        DlrPoliciesComponent, AddDlrPolicyComponent, DlrUndelMccComponent, DlrUndelMsisdnComponent, DlrSummaryComponent,
        ViewDlrSummaryChartComponent, RegexEditorComponent,
        ClickerSummaryComponent
    ],
    imports: [
        CommonModule,
        AceModule,
        NavigationRoutingModule,
        FormsModule, NgxCsvParserModule,
        ReactiveFormsModule, MatDialogModule, MatSnackBarModule, MatTooltipModule,
        MatButtonModule, MatCheckboxModule, MatIconModule, MatPaginatorModule, MatSelectModule,
        MatSidenavModule, MatNativeDateModule, MatDatepickerModule, MatTableModule, MatInputModule,
        MatCardModule, MatToolbarModule, MatListModule, MatExpansionModule, MatBadgeModule, MatMenuModule,
        MatSortModule, MatPaginatorModule, MatGridListModule, MatTabsModule, MatFormFieldModule,
        MatProgressSpinnerModule, MatAutocompleteModule, MatSlideToggleModule, MatSliderModule,
        [NgxMaterialTimepickerModule.setLocale('en-GB')], MatSlideToggleModule, MatStepperModule, MatProgressBarModule,
        MatRadioModule, ScrollingModule,  MatTreeModule, CKEditorModule,
        FlexLayoutModule,
        VirtualScrollerModule, TableVirtualScrollModule, ClipboardModule,
        NgxMaskModule.forRoot(),
        ChartsModule,
        DeviceDetectorModule.forRoot(),
        DragDropModule,
        ResizableModule,
        PersistenceModule,
        NgxQRCodeModule
    ],
    providers: [
        FormsModule,
        JwtService,
        AuthGuard,
        DatePipe,
        { provide: MAT_SNACK_BAR_DEFAULT_OPTIONS, useValue: { duration: 2500 } },
        /*     {
              provide: HTTP_INTERCEPTORS,
              useClass: HttpLogInterceptor,
              multi: true
            }, */
        {
            provide: MatDialogRef,
            useValue: {}
        },
        { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
        { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
        { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } },
        { provide: DateAdapter, useClass: MomentUtcDateAdapter },
        {
            provide: ACE_CONFIG,
            useValue: DEFAULT_ACE_CONFIG
        }
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class NavigationModule { }
